let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lDz4b")).then(() => parcelRequire('iffwU'));